module.exports = __webpack_public_path__ + "img/TC29.26a7c6db.jpg";